import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  SidebarProvider,
  SidebarTrigger,
  SidebarInset,
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '../ui';
import AppSidebar from './AppSidebar';
import ImpersonationBanner from './ImpersonationBanner';

const mobileSafeAreaTop = {
  paddingTop: 'max(0.75rem, env(safe-area-inset-top))'
};
const mobileHeaderSpacing = {
  paddingBottom: '0.75rem'
};

// Header component con breadcrumbs
const DetailHeader = ({ title, subtitle, breadcrumbs, backPath, backLabel = "Regresar" }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (backPath) {
      navigate(backPath);
    } else {
      navigate(-1); // Ir hacia atrás en el historial
    }
  };

  return (
    <header
      className="flex min-h-16 shrink-0 items-center gap-2 border-b bg-background px-4 md:pt-0 md:pb-0"
      style={{ ...mobileSafeAreaTop, ...mobileHeaderSpacing }}
    >
      <div className="flex items-center gap-2">
        <SidebarTrigger />
      </div>

      <div className="flex flex-col flex-1 min-w-0 px-2">
        {breadcrumbs && breadcrumbs.length > 0 && (
          <Breadcrumb className="mb-0.5">
            <BreadcrumbList>
              {breadcrumbs.map((crumb, index) => (
                <React.Fragment key={index}>
                  <BreadcrumbItem>
                    {index < breadcrumbs.length - 1 ? (
                      <BreadcrumbLink
                        onClick={() => crumb.path && navigate(crumb.path)}
                        className={crumb.path ? "cursor-pointer hover:text-foreground" : "cursor-default"}
                      >
                        {crumb.label}
                      </BreadcrumbLink>
                    ) : (
                      // El ultimo tramo ES el titulo de la pantalla: las vistas de
                      // detalle ya no repiten el nombre en el contenido, asi que
                      // aqui carga el peso visual que antes tenia el CardTitle.
                      <BreadcrumbPage className="text-base font-semibold text-foreground truncate max-w-[55vw] sm:max-w-none">
                        {crumb.label}
                      </BreadcrumbPage>
                    )}
                  </BreadcrumbItem>
                  {index < breadcrumbs.length - 1 && <BreadcrumbSeparator />}
                </React.Fragment>
              ))}
            </BreadcrumbList>
          </Breadcrumb>
        )}
        {title && !breadcrumbs?.length && (
          <h1 className="text-lg font-semibold text-foreground truncate">{title}</h1>
        )}
        {subtitle && (
          <p className="text-xs text-muted-foreground truncate">{subtitle}</p>
        )}
      </div>
    </header>
  );
};

// Layout principal para páginas de detalle
const DetailLayout = ({
  children,
  title,
  subtitle,
  breadcrumbs = [],
  backPath,
  backLabel = "Regresar",
  refreshAction
}) => {
  return (
    <SidebarProvider>
      <div className="flex h-screen w-full overflow-hidden">
        <AppSidebar refreshAction={refreshAction} />
        <SidebarInset className="flex-1 min-w-0 overflow-hidden">
          <ImpersonationBanner />
          <DetailHeader
            title={title}
            subtitle={subtitle}
            breadcrumbs={breadcrumbs}
            backPath={backPath}
            backLabel={backLabel}
          />
          <div className="flex-1 overflow-y-auto">
            <div className="container mx-auto px-2 sm:px-4 lg:px-6 py-4 lg:py-6 max-w-full overflow-x-hidden">
              {children}
            </div>
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};

export default DetailLayout;

